import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import { BrowserQRCodeReader, DecodeHintType, BarcodeFormat } from '@zxing/library'

// 모바일 웹용 실시간 QR 스캔 화면 (앱 WebView 가 아닌 환경에서 사용). HTTPS 필수.
const overlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 100000,
  background: '#000',
  display: 'flex',
  flexDirection: 'column',
}
const videoStyle = { flex: 1, width: '100%', objectFit: 'cover', minHeight: 0 }
const guideStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  width: '65%',
  maxWidth: 320,
  aspectRatio: '1 / 1',
  transform: 'translate(-50%, -50%)',
  border: '3px solid #fff',
  borderRadius: 12,
  pointerEvents: 'none',
}
const textStyle = { color: '#fff', textAlign: 'center', padding: '12px 16px', fontSize: 15 }
const closeStyle = { margin: '0 16px 20px', padding: '14px 0', fontSize: 16, border: 0, borderRadius: 8 }

const QrScanModal = ({ onResult, onError, onClose }) => {
  const videoRef = useRef(null)

  useEffect(() => {
    let done = false
    const reader = new BrowserQRCodeReader(300)
    const hints = new Map()
    hints.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.QR_CODE])
    hints.set(DecodeHintType.TRY_HARDER, true)
    reader.hints = hints

    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      onError('이 브라우저에서는 카메라를 사용할 수 없습니다. (HTTPS 접속 및 카메라 권한이 필요합니다.)')
      return undefined
    }

    reader
      .decodeFromConstraints({ video: { facingMode: { ideal: 'environment' } }, audio: false }, videoRef.current, (result) => {
        if (result && !done) {
          done = true
          reader.reset()
          onResult(result.getText())
        }
      })
      .catch((err) => {
        if (!done) onError('카메라를 시작하지 못했습니다. 카메라 권한을 허용해 주세요. (' + (err && err.name) + ')')
      })

    return () => {
      done = true
      reader.reset()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return ReactDOM.createPortal(
    <div style={overlayStyle}>
      <div style={textStyle}>위변조확인할 QR코드를 사각형 안에 맞춰 주세요.</div>
      <div style={{ position: 'relative', flex: 1, display: 'flex', minHeight: 0 }}>
        <video ref={videoRef} style={videoStyle} playsInline muted autoPlay />
        <div style={guideStyle} />
      </div>
      <button type="button" style={closeStyle} onClick={onClose}>
        닫기
      </button>
    </div>,
    document.body
  )
}

export default QrScanModal
